<template>
  <kst-container class="kst-sales-details">
    <kst-form
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :loading="isLoading"
      :title="title"
      :warnings="formWarnings"
    >
      <template #top-right>
        <Action :data="data"/>
      </template>
      
      <b-tabs v-model="activeTab" size="is-medium" type="is-boxed">
        <b-tab-item :label="tabs.Details">
          <Details :data="data"/>
          <Items :data="data" :items="data.Items"/>
          <Total :data="data"/>
        </b-tab-item>
        <b-tab-item :label="tabs.InvoiceList">
          <InvoiceRelated :items="data.InvoiceList" :salesId="data.ID"/>
        </b-tab-item>
      </b-tabs>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../SalesInfo.js";
import Model from "../SalesModel.js";
import Services from "../SalesServices.js";

import Action from "./SalesDetails_Action";
import Details from "./SalesDetails_Details";
import Items from "./SalesDetails_Items";
import Total from "./SalesDetails_Total";
import InvoiceRelated from "@/components/Invoice/Related/InvoiceRelated";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Action,
    Details,
    Items,
    Total,
    InvoiceRelated
  },
  data: () => ({
    data: {},
    isLoading: false,
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details,
      InvoiceList: Info.Tabs.InvoiceList
    },
    // error
    formWarnings: null,
    failureInit: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.data = {};

      this.initLoad(id);
    },
    initLoad(id) {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetails(id) {
      const options = { withpackagings: 1, withstock: 1, withinvoice: 1, withinvoicecount: 1 };
      const config = Services.getSalesDetails(id, options);
      this.runAxios(config, null, this.loadDetails_Success, this.loadDetails_Error);
    },
    loadDetails_Success(data) {
      this.data = data;
      Model.setDetailsByStatus(this.data);

      for (const item of this.data.Items) {
        Model.updateItemByPackaging(item);
      }

      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    }
  }
}
</script>